<div class="desktop">
  @if (appointmentText?.back) {
    <div class="back-button" nz-col nzSpan="24" [routerLink]="backLink">
      <span nz-icon nzType="arrow-left" nzTheme="outline"></span>
      {{ appointmentText?.back }}
    </div>
  }
  @if (appointmentText?.secondTitle) {
    <div class="header">
      @if (searchEnabled) {
        <p class="title">{{ appointmentText?.title }}</p>
      }
      <p class="second-title">{{ appointmentText?.secondTitle }}</p>
      @if (appointmentText?.thirdTitle) {
        <p class="third-title">{{ appointmentText?.thirdTitle }}</p>
      }
      <nz-divider></nz-divider>
    </div>
  }
  @if (searchEnabled) {
    <div class="container-appointments">
      <div nz-row class="container-desktop" nzGutter="24">
        <div nz-col nzSpan="7">
          <ds-search [control]="searchValues.commonInput.control" [placeholder]="'medicalConsultations.placeholderSearch' | translate"> </ds-search>
        </div>
        <div nz-col nzSpan="12">
          <ds-datepicker
            [control]="searchValues.dateInput.control"
            [endControl]="searchValues.dateInput.endControl"
            [placeholder]="'medicalConsultations.placeholderDatepicker' | translate"
            [secondPlaceholder]="'medicalConsultations.secondPlaceholder' | translate"
            [startDate]="searchValues.dateInput.startDate"
            [endDate]="searchValues.dateInput.endDate"
            [middleText]="'medicalConsultations.middleText' | translate"
            [label]="'medicalConsultations.labelDatepicker' | translate"
          ></ds-datepicker>
        </div>
        @if (innerFiltersEnabled) {
          <div nz-col nzSpan="2" class="filter-button" (click)="isOpen = !isOpen">
            <span nz-icon nzType="filter" nzTheme="outline"></span>
            <span>{{ 'appointmentsTable.filter' | translate }} ({{ activeFilters }})</span>
          </div>
        }
      </div>
      @if (innerFiltersEnabled && isOpen) {
        <div class="select-row" nz-row>
          @for (select of innerSelectData; track select) {
            <div nz-col nzSpan="8">
              <ds-select [placeholder]="select.placeholder" [label]="select.label" [texts]="select.elements" [values]="select.elements" [control]="select.control"></ds-select>
            </div>
          }
        </div>
      }
    </div>
  }

  @if (displayedAppointments && displayedAppointments) {
    <nz-table [nzBordered]="true" [nzData]="displayedAppointments" [nzPageSize]="pageSize" [nzShowPagination]="false">
      <thead>
        <tr>
          @if (hasCheckbox) {
            <th nzWidth="25px">
              <label nz-checkbox [(ngModel)]="allChecked" (ngModelChange)="onSelectAll($event)" aria-label="Seleziona tutti gli appuntamenti"></label>
            </th>
          }
          @for (data of columns; track $index) {
            <th>
              {{ data?.value }}
              <span nz-tooltip *ngIf="data?.hasTooltip" nzTooltipTitle="{{ data.tooltipText }}">
                <i nz-icon nzType="info-circle" nzTheme="outline"></i>
              </span>
            </th>
          }
          @if (!hiddenLastSegment) {
            <th></th>
          }
        </tr>
      </thead>
      <tbody>
        @for (data of displayedAppointments; track $index) {
          @if ($index <= columns?.length) {
            <ng-container>
              <tr>
                @if (hasCheckbox) {
                  <td>
                    <label nz-checkbox [(ngModel)]="data.checked" (ngModelChange)="onRowSelectionChange(data)" [attr.aria-label]="'Seleziona appuntamento con ' + data?.name"></label>
                  </td>
                }
                @if (hasField('consultDate')) {
                  <td>{{ data?.consultDate ?? '-' }}</td>
                }

                @if (hasField('time')) {
                  <td>{{ data?.time ?? '-' }}</td>
                }

                @if (hasField('value')) {
                  <td>
                    <b>{{ data?.value ?? '-' }}</b>
                  </td>
                }

                @if (hasField('name')) {
                  <td>{{ data?.name ?? '-' }}</td>
                }

                @if (hasField('consultType')) {
                  <td>{{ getDocumentType(data) }}</td>
                }

                @if (hasField('specialist')) {
                  <td>{{ getPrestation(data?.consultType) }}</td>
                }

                @if (hasField('specialistNotTranslated')) {
                  <td>{{ getPrestazioneByContext(data) }}</td>
                }

                @if (hasField('fullName') && isFrom !== 'home-page') {
                  <td>{{ data?.fullName ?? '-' }}</td>
                }

                @if (hasField('chargedBy')) {
                  <td>
                    <b>{{ data?.chargedBy ?? '-' }}</b>
                  </td>
                }

                @if (hasField('isAdult')) {
                  <td class="center">
                    @if (data?.isMajorDelegateEnabled !== undefined && data?.isAdult) {
                      <nz-switch [nzDisabled]="data.isMajorDelegateEnabled" [attr.tabindex]="data.isMajorDelegateEnabled ? -1 : 0" [attr.aria-label]="'Gestisci la condivisione del profilo di ' + data.fullName" [(ngModel)]="data.isMajorDelegateEnabled" (click)="emitShare(data)"></nz-switch>
                    } @else {
                      -
                    }
                  </td>
                }

                @if (hasField('isMinorDelegateEnabled')) {
                  <td class="center">
                    @if (data?.isMinorDelegateEnabled && data?.isShared !== undefined) {
                      <nz-switch [nzDisabled]="data.isShared" [attr.tabindex]="data.isShared ? -1 : 0" [attr.aria-label]="'Gestisci la condivisione del profilo con ' + data.fullName" [(ngModel)]="data.isShared" (click)="emitShare(data)"></nz-switch>
                    } @else {
                      -
                    }
                  </td>
                }

                @if (hasField('isPrivateArea')) {
                  <td class="center">
                    @if (data?.isPrivateArea !== undefined) {
                      <span class="check-icon" nz-icon nzType="check-circle" nzTheme="outline"></span>
                    } @else {
                      <span class="close-icon" nz-icon nzType="close-circle" nzTheme="outline"></span>
                    }
                  </td>
                }

                @if (hasField('status')) {
                  <td>
                    @if (data?.status) {
                      <nz-badge [style]="getBadgeBackground(data.status)" [nzStatus]="getBadgeStatus(data.status)" [nzText]="data.statusText | translate"></nz-badge>
                    } @else {
                      -
                    }
                  </td>
                }

                @if (hasField('fullNamePayment')) {
                  <td>{{ data?.fullNamePayment ?? '-' }}</td>
                }

                @if (hasField('course')) {
                  <td>
                    @if (data?.course) {
                      <img [src]="getIconUrl(data?.course)" alt="" />
                    } @else {
                      -
                    }
                  </td>
                }

                @if (hasField('action')) {
                  <td>
                    @if (data?.action) {
                      <a role="button" tabindex="0" (click)="emitClick(data)" (keydown.enter)="emitClick(data)" (keydown.space)="emitClick(data); $event.preventDefault()">{{ data.action }}</a>
                    } @else {
                      -
                    }
                  </td>
                }

                @if (hasField('startDate')) {
                  <td>{{ data?.startDate ?? '-' }}</td>
                }

                @if (hasField('endDate')) {
                  <td>{{ data?.endDate ?? '-' }}</td>
                }

                @if (hasField('dropdown')) {
                  <td>
                    @if (data?.dropdown) {
                      <nz-dropdown>
                        <span
                          style="position: relative; display: inline-block;"
                          nz-dropdown
                          nzTrigger="click"
                          [nzDropdownMenu]="recordActionsMenu"
                          role="button"
                          tabindex="0"
                          (keydown.enter)="triggerDropdown($event)"
                          (keydown.space)="triggerDropdown($event)"
                          nz-icon
                          nzType="more"
                          nzTheme="outline"
                        ></span>
                        <nz-dropdown-menu #recordActionsMenu="nzDropdownMenu">
                          <div class="actions-menu">
                            <button class="btn-delete" nz-button nzType="link" nzAccessible aria-label="Scarica il file dell'appuntamento" (click)="downloadFile(data, true, $index)">{{ 'buttons.download' | translate | titlecase }}</button>
                            <button class="btn-delete" nz-button nzType="link" nzAccessible aria-label="Elimina il file dell'appuntamento" (click)="deleteFile(data, $index)">{{ 'buttons.delete' | translate | titlecase }}</button>
                          </div>
                        </nz-dropdown-menu>
                      </nz-dropdown>
                    } @else {
                      -
                    }
                  </td>
                }
                @if (hasField('dropdownRec')) {
                  <td>
                    @if (data?.dropdownRec) {
                      <nz-dropdown>
                        <span
                          style="position: relative; display: inline-block;"
                          nz-dropdown
                          nzTrigger="click"
                          [nzDropdownMenu]="recordEditActionsMenu"
                          role="button"
                          tabindex="0"
                          (keydown.enter)="triggerDropdown($event)"
                          (keydown.space)="triggerDropdown($event)"
                          nz-icon
                          nzType="more"
                          nzTheme="outline"
                        ></span>
                        <nz-dropdown-menu #recordEditActionsMenu="nzDropdownMenu">
                          <div class="actions-menu">
                            <button class="btn-edit" nz-button nzType="link" nzAccessible aria-label="Modifica il record" (click)="editRecord(data.key, data.item)">
                              {{ 'buttons.edit' | translate | titlecase }}
                            </button>
                            <button class="btn-delete" nz-button nzType="link" nzAccessible aria-label="Elimina il record" (click)="delete(data.key, data.item)">
                              {{ 'buttons.delete' | translate | titlecase }}
                            </button>
                          </div>
                        </nz-dropdown-menu>
                      </nz-dropdown>
                    } @else {
                      -
                    }
                  </td>
                }
                @if (isFrom === 'home-page') {
                  <td>
                    <img style="cursor: pointer" src="../../../../public/assets/images/Collapse.svg" (click)="toggleAccordion($index)" />
                  </td>
                }
                @if (hasField('delete')) {
                  @if (data?.delete) {
                    <td class="center">
                      <nz-dropdown>
                        <a nz-dropdown style="position: relative; display: inline-block;" nzTrigger="click" [nzDropdownMenu]="deleteMenu">
                          <img src="../../../../public/assets/images/point.svg" />
                        </a>
                        <nz-dropdown-menu #deleteMenu="nzDropdownMenu">
                          <div class="delete-container">
                            <p class="delete" (click)="openModal(data.connectionId, data.fullName)">Elimina profilo</p>
                            @if (data?.email === null) {
                              <p class="delete" (click)="addEmailEmit(data)">Inserisci email</p>
                            }
                          </div>
                        </nz-dropdown-menu>
                      </nz-dropdown>
                    </td>
                  } @else {
                    <td>-</td>
                  }
                }
              </tr>

              <tr *ngIf="expandedRows[$index]">
                <td class="dropdown-row" colspan="6">
                  <nz-row class="container-info">
                    <nz-col class="info" nzSpan="6">
                      <span class="title">{{ 'appointmentsTable.argument' | translate }}</span>
                      <span class="value">{{ data.mainSymptom ?? '---' }}</span>
                    </nz-col>
                    <nz-col class="info" nzSpan="18">
                      <span class="title">{{ 'appointmentsTable.reason' | translate }}</span>
                      <span class="value">{{ data.message ?? '---' }}</span>
                    </nz-col>
                    <nz-divider></nz-divider>
                    <nz-col class="info" nzSpan="14">
                      <span class="title">{{ 'appointmentsTable.docValutation' | translate }}</span>
                      <span class="value">{{ data.medicalMessageResponse ?? '---' }}</span>
                    </nz-col>
                  </nz-row>
                    <div class="classic-link">
                      @if( data?.consultType !== 'GenericPhone' &&
                      data?.consultType !== 'GenericVideo' &&
                      data?.consultType !== 'GenericTelevisitVideo' &&
                      data?.consultType !== 'CareManager' &&
                      (data?.status.toLowerCase() === 'readytoassist' ||
                        data?.status.toLowerCase() === 'confirmed' ||
                        data?.status.toLowerCase() === 'awaiting'))
                      {
                        <a class="manage-link" role="button" tabindex="0" (click)="openManageModal(data)" (keydown.enter)="openManageModal(data)" (keydown.space)="openManageModal(data); $event.preventDefault()">{{'medicalConsultations.handleTextTwo' | translate }}</a>
                      }
                        <a role="button" tabindex="0" (click)="redirectAppointmentsDetail(data.consultRequestId)" (keydown.enter)="redirectAppointmentsDetail(data.consultRequestId)" (keydown.space)="redirectAppointmentsDetail(data.consultRequestId); $event.preventDefault()">{{ 'appointmentsTable.details' | translate }}</a>
                    </div>
                </td>
              </tr>
            </ng-container>
          }
        }
      </tbody>
    </nz-table>
    @if (totalPages > 1) {
      <div class="pagination">
        <nz-pagination [(nzPageIndex)]="currentPage" [nzTotal]="filteredAppointments?.length" [nzPageSize]="pageSize" (nzPageIndexChange)="onPageChange($event)"> </nz-pagination>
      </div>
    }
  }
</div>
<div class="mobile">
  <div class="back-button" nz-col nzSpan="24">
    <i></i>
    {{ appointmentText?.texts }}
  </div>
  @if (appointmentText?.titleMobile && filteredAppointments?.length > 0) {
    <div class="header-mobile">
      <i class="icon"></i>
      <p class="title">{{ appointmentText?.titleMobile }}</p>
    </div>
  }
  @if (searchEnabled) {
    <div class="container-appointments-mobile" [ngClass]="dropdownOpen ? 'opened' : ''">
      <div nz-row nzGutter="24" class="row-mobile-search">
        <div nz-col nzSpan="24">
          <ds-search [control]="searchValues.commonInput.control" [placeholder]="appointmentText?.placeholderSearch"> </ds-search>
        </div>
        <div nz-col nzSpan="24" style="justify-content: space-between; display: flex">
          <div>
            <div class="filter-button"><i nz-icon nzType="filter" nzTheme="outline"></i> {{ 'appointmentsTable.filter' | translate }} {{activeFilters}}</div>
          </div>
          <div class="filter-container">
            <span (click)="openDropdown()">{{ 'appointmentsTable.orderBy' | translate }}</span>
          </div>
        </div>
        @if (dropdownOpen) {
          <div nz-row class="row-mobile">
            <div nz-col nzSpan="24">
              <ds-datepicker
                [control]="searchValues.dateInput.control"
                [endControl]="searchValues.dateInput.endControl"
                [placeholder]="appointmentText?.placeholderDatepicker"
                [secondPlaceholder]="appointmentText?.secondPlaceholder"
                [startDate]="searchValues.dateInput.startDate"
                [endDate]="searchValues.dateInput.endDate"
                [middleText]="appointmentText?.middleText"
                [label]="appointmentText?.labelDatepicker"
              ></ds-datepicker>
            </div>
            @if (innerFiltersEnabled && isOpen) {
              <div class="select-row" nz-row>
                @for (select of innerSelectData; track select) {
                  <div nz-col nzSpan="24">
                    <ds-select
                      [placeholder]="select.placeholder"
                      [label]="select.label"
                      [texts]="select.elements"
                      [values]="select.elements"
                      [control]="select.control"
                    ></ds-select>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
  <nz-row class="table-row">
    @if (appointmentText?.subtitle && filteredAppointments.length > 0) {
      <span class="subtitle">{{ appointmentText?.subtitle }}</span>
    }
    @for (data of filteredAppointments; track data; let i= $index) {
      <div nz-col nzSpan="24">
        <nz-card nzBordered="false" class="card" [nzBodyStyle]="{ padding: '0' }">
            @if (isFrom === 'misurations') {
              <div style="display: flex; justify-content: space-between;" >
                 @if(data.type){
                <span class="type-label">
                  {{  getTypeLabel(data.type) }}
                </span>
              }
              <div style="display: flex;">
                    @if (data.status) {
                <td>
                  <nz-badge [style]="getBadgeBackground(data.status)" [nzStatus]="getBadgeStatus(data.status)" [nzText]="data.statusText | translate"></nz-badge>
                </td>
              }
                @if (hasField('delete') || hasField('action')) {
                <span class="center">
                  <nz-dropdown>
                    <a nz-dropdown style="position: relative; display: inline-block;" nzTrigger="click" [nzDropdownMenu]="deleteMenu">
                      <img src="../../../../public/assets/images/point.svg" />
                    </a>
                    <nz-dropdown-menu #deleteMenu="nzDropdownMenu">
                      <div class="dropdown">
                        @if (data?.action) {
                          <p (click)="emitClick(data)">{{ data.action }}</p>
                        } @else {
                          <p>-</p>
                        }
                      </div>
                    </nz-dropdown-menu>
                  </nz-dropdown>
                </span>
              }
              </div>
            </div>
            <nz-divider></nz-divider>
            <div class="misuration-mobile-isfrom">
                  <div class="details">
                    @if (data?.value !== undefined && data?.value !== null) {
                      <td>
                        <b>{{ data.value }} {{getUnit(data.type)}}</b>
                      </td>
                    }
                    @if (data?.consultDate) {
                      <td class="date">{{ data?.consultDate ?? '-' }}</td>
                    }
                  </div>
                  <div class="dates">
                    @if (data?.startDate) {
                      <td class="date">{{ data?.startDate ?? '-' }}</td>
                    }
                    @if (data?.endDate) {
                      <td class="date">{{ data?.endDate ?? '-' }}</td>
                    }
                  </div>
              </div>
            }
            @if (isFrom !== 'misurations') {
            <div style="display: flex; justify-content: space-between; flex-direction: row-reverse;">
                @if (hasField('dropdown')) {
                  @if (data?.dropdown) {
                    <nz-dropdown>
                      <span
                        nz-dropdown
                        style="position: relative; display: inline-block;"
                        nzTrigger="click"
                        [nzDropdownMenu]="clickActionsMenu"
                        role="button"
                        tabindex="0"
                        (keydown.enter)="triggerDropdown($event)"
                        (keydown.space)="triggerDropdown($event)"
                        nz-icon
                        nzType="more"
                        nzTheme="outline"
                      ></span>
                      <nz-dropdown-menu #clickActionsMenu="nzDropdownMenu">
                        <div class="actions-menu">
                          <button class="btn-delete" nz-button nzType="link" (click)="downloadFile(data, true, i)">
                            {{ 'buttons.download' | translate | titlecase }}
                          </button>
                          <button class="btn-delete" nz-button nzType="link" (click)="deleteFile(data, i)">
                            {{ 'buttons.delete' | translate | titlecase }}
                          </button>
                        </div>
                      </nz-dropdown-menu>
                    </nz-dropdown>
                  } @else {
                        -
                  }
                }
            @if (!hasField('misuration')) {
              <div class="header">
                @if (hasField('consultType')) {
                  <span>{{ getDocumentType(data) }}</span>
                }
                @if (data.status) {
                  <td>
                    <nz-badge [style]="getBadgeBackground(data.status)" [nzStatus]="getBadgeStatus(data.status)" [nzText]="data.statusText | translate"></nz-badge>
                  </td>
                }
                @if (hasField('fullName') && isFrom !== 'home-page') {
                  <p>{{ data?.fullName ?? '-' }}</p>
                }
                 @if (hasField('delete') || hasField('action')) {
                  <span class="center">
                    <nz-dropdown>
                      <a nz-dropdown style="position: relative; display: inline-block;" nzOverlayClassName="table-delete-dropdown" nzPlacement="bottomRight" nzTrigger="click" [nzDropdownMenu]="deleteMenu">
                        <img src="../../../../public/assets/images/point.svg" />
                      </a>
                      <nz-dropdown-menu #deleteMenu="nzDropdownMenu">
                        <div class="dropdown">
                          @if (data?.delete) {
                            <p (click)="openModal(data.connectionId, data.fullName)">Elimina profilo</p>
                          }
                          @if (data?.action) {
                            <p (click)="emitClick(data)">{{ data.action }}</p>
                          } @else {
                            <p>-</p>
                          }
                          @if (data?.email === null) {
                            <p (click)="addEmailEmit(data)">Inserisci email</p>
                          }
                        </div>
                      </nz-dropdown-menu>
                    </nz-dropdown>
                  </span>
                }
               
              </div>
            }
            </div>
            
            @if (hasField('specialist')) {
              <nz-divider></nz-divider>
              <div class="container-value">
                <div class="info">
                  <p class="title">{{ getPrestazioneByContext(data) }}</p>
                  @if (data?.value || data?.value === 0) {
                    <p class="value">
                      <b>{{ data?.value }}</b>
                    </p>
                  }
                  <p class="value">{{ data.consultDate }}</p>
                </div>
                @if (data.missionId) {
                  <div class="info">
                    <a role="button" tabindex="0" (click)="redirectAppointmentsDetail(data.consultRequestId)" (keydown.enter)="redirectAppointmentsDetail(data.consultRequestId)" (keydown.space)="redirectAppointmentsDetail(data.consultRequestId); $event.preventDefault()" class="link">{{ 'appointmentsTable.detail' | translate }}</a>
                    <p class="value id">#{{ data.missionId }}</p>
                  </div>
                }
              </div>
            }
            @if (hasField('isAdult') || hasField('isMinorDelegateEnabled')) {
              <div class="user-managment-mobile">
                <nz-table [nzBordered]="true" [nzData]="displayedAppointments" [nzPageSize]="pageSize" [nzShowPagination]="false">
                  <thead>
                    <tr>
                      <th>
                        <span
                          >Profilo Condiviso<span nz-tooltip nzTooltipTitle="Se condividi il tuo profilo, la persona che hai scelto avrà accesso ai tuoi dati sanitari etc..">
                            <i nz-icon nzType="info-circle" nzTheme="outline"></i> </span
                        ></span>
                      </th>
                      <th>
                        <span>Gestione Profilo</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      @if (data.isAdult) {
                        <td class="center">
                          @if (data?.isMajorDelegateEnabled !== undefined && data?.isAdult) {
                            <nz-switch [nzDisabled]="data.isMajorDelegateEnabled" [attr.tabindex]="data.isMajorDelegateEnabled ? -1 : 0" [attr.aria-label]="'Gestisci la condivisione del profilo di ' + data.fullName" [(ngModel)]="data.isMajorDelegateEnabled" (click)="emitShare(data)"></nz-switch>
                          } @else {
                            -
                          }
                        </td>
                      } @else {
                        <td class="center">
                          @if (data?.isMinorDelegateEnabled && data?.isShared !== undefined) {
                            <nz-switch [nzDisabled]="data.isShared" [attr.tabindex]="data.isShared ? -1 : 0" [attr.aria-label]="'Gestisci la condivisione del profilo con ' + data.fullName" [(ngModel)]="data.isShared" (click)="emitShare(data)"></nz-switch>
                          } @else {
                            -
                          }
                        </td>
                      }
                      @if (hasField('isPrivateArea')) {
                        <td class="center">
                          @if (data?.isPrivateArea !== undefined) {
                            <span class="check-icon" nz-icon nzType="check-circle" nzTheme="outline"></span>
                          } @else {
                            <span class="close-icon" nz-icon nzType="close-circle" nzTheme="outline"></span>
                          }
                        </td>
                      } @else {
                        <td class="center">-</td>
                      }
                    </tr>
                  </tbody>
                </nz-table>
              </div>
            }
            @if (hasField('misuration')) {
              <div class="misuration-mobile">
                <div class="details">
                  @if (hasField('time')) {
                    <td>
                      <b>{{ data?.time ?? '-' }}</b>
                    </td>
                  }
                  @if (hasField('consultDate')) {
                    <td class="date">{{ data?.consultDate ?? '-' }}</td>
                  }
                </div>
                <div class="dates">
                  @if (hasField('startDate')) {
                    <td class="date">{{ data?.startDate ?? '-' }}</td>
                  }
                  @if (hasField('endDate')) {
                    <td class="date">{{ data?.endDate ?? '-' }}</td>
                  }
                </div>
              </div>
            }
          }
        </nz-card>
      </div>
    }
  </nz-row>
</div>


<nz-modal
  [(nzVisible)]="isModalVisible"
  [nzTitle]="'medicalConsultations.type' | translate"
  (nzOnCancel)="closeModal()"
  nzCentered
  >
  <ng-container *nzModalContent>
  <p class="modal-subtitle">
      {{ 'medicalConsultations.modalSubTitle' | translate }}
  </p>
  <div nz-row [nzGutter]="16" class="container-values">
  <div class="info" nz-col nzSpan="12">
  <p class="title">{{ 'medicalConsultations.type' | translate }}</p>
  <p class="value">{{ getTipologia(selectedAppointment?.consultType) }}</p>
  </div>
  <div class="info" nz-col nzSpan="12">
  <p class="title">{{ 'medicalConsultations.prestation' | translate }}</p>
  <p class="value">{{ getPrestazione(selectedAppointment?.consultType) }}</p>
  </div>
  <div class="info" nz-col nzSpan="12">
  <p class="title">{{ 'medicalConsultations.date' | translate }}</p>
  <p class="value">{{ selectedAppointment?.appointmentStartDate ? convertDate(selectedAppointment?.appointmentStartDate, true) : selectedAppointment?.consultDate }}</p>
  </div>
  <div class="info" nz-col nzSpan="12">
  <p class="title">{{ 'medicalConsultations.time' | translate }}</p>
  <p class="value">{{ selectedAppointment?.appointmentStartDate ? convertDate(selectedAppointment?.appointmentStartDate, false) : selectedAppointment?.time }}</p>
  </div>
  <div class="actions">
  <a class="delete" role="button" tabindex="0" (click)="deleteAppointment(selectedAppointment)" (keydown.enter)="deleteAppointment(selectedAppointment)" (keydown.space)="deleteAppointment(selectedAppointment); $event.preventDefault()">{{ 'medicalConsultations.delete' | translate }}</a>
  <a class="modify" role="button" tabindex="0" (click)="toggleEditMode(selectedAppointment)" (keydown.enter)="toggleEditMode(selectedAppointment)" (keydown.space)="toggleEditMode(selectedAppointment); $event.preventDefault()">{{ 'medicalConsultations.modify' | translate }}</a>
  </div>
  </div>
  </ng-container>
  <div *nzModalFooter>
  <div class="buttons">
  <ds-button (click)="closeModal()" [text]="'ESCI'" [width]="'small'" [styleType]="'default-main'"></ds-button>
  </div>
  </div>
</nz-modal>
